// functions
import { useState } from "react";
import { toast } from "react-toastify";

// libraries
import classNames from "classnames/bind";

//styles
import styles from "./styles.module.scss";
const cx = classNames.bind(styles);

const Feedback = () => {
  const [isShown, setIsShown] = useState(false);

  const toggleShown = () => {
    setIsShown((s) => !s);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const checkedRadio = [...event.target.type].find((el) => el.checked);
    const feedbackType = checkedRadio.dataset.label;
    const description = event.target.description.value;

    console.log({ feedbackType, description });

    toast.success("Thank you for the feedback");

    toggleShown();
  };

  return (
    <div className={cx("feedback-root")}>
      <button className={cx("feedback-toggler")} onClick={toggleShown}>
        Feedback
      </button>
      <div className={cx("feedback-popup", isShown ? "shown" : "hidden")}>
        <div className={cx("title")}>Feedback</div>
        <form className={cx("content")} onSubmit={handleSubmit}>
          <FeedbackType label="Inappropriate Event" defaultChecked />
          <FeedbackType label="Event Support" />
          <FeedbackType label="Bugs" />
          <FeedbackType label="Event listed in a error" />
          <div className={cx("description")}>
            <label htmlFor="description">Description</label>
            <textarea
              name="description"
              id="description"
              placeholder="Write your description"
            ></textarea>
          </div>
          <div className={cx("buttons")}>
            <button
              className={cx("cancel")}
              onClick={toggleShown}
              type="button"
            >
              Cancel
            </button>
            {/* <input className={cx("submit")} type="submit" value="Submit" /> */}
            <button className={cx("submit")} type="submit">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const FeedbackType = ({ label, defaultChecked }) => {
  // TODO: Need a better idea
  const id = label.split(" ")[0].toLowerCase() + "_" + Math.random().toString();

  return (
    <div className={cx("type")}>
      <div className={cx("radio-btn")}>
        <input
          type="radio"
          name="type"
          id={id}
          data-label={label}
          defaultChecked={defaultChecked}
        />
        <div className={cx("mark")}></div>
      </div>
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

export default Feedback;
